<template>
    <div class=" helpdesk-ticket">
        <div class="ticket-header">
            <div>
                <img src="/static/images/new-theme2024/update_ticket_status.svg" class="mx-6 " width="50">
                <span class="fs-16 fw-600 text-blue-new highlighted">Update Ticket Status</span>
            </div>
            <div>
                <img src="/static/images/new-theme2024/close-circle.svg" @click="closeFilters()" class="mr-2 mb-15 pointer" width="25">
            </div>
        </div>
        <div class="w-100">
            <div v-if="loader || save_loader" class="d-flex align-items-center justify-content-center" style="background-color: #ffffff !important;">
                <img src="/static/images/new-theme2024/20 card.gif" class="my-4" width="100" alt="">
            </div>
            <div v-else class="general-section px-4 pb-5">
                <div class="v-modal-body pt-0 pb-0" style="max-height: 410px;overflow: auto;">
                    <div class="d-form px-2 " style="overflow: initial !important;">
                        <div class="d-flex align-items-center justify-content-between">
                        </div>
                        <div class="d-flex px-3 justify-content-center " style="flex-direction: column;margin-top: -74px;">
                            <div class="d-flex justify-content-between" v-for="(item,index) in api_options" :key="index">
                                <div class="d-flex status-stages" v-if="item.name != 'Re-Open' && item.name != 'Discard'">
                                    <div>
                                        <div class="status-stages-line mt-11"  :class="{'margin-top-hide' : index<1}" style="margin-left: 1.4rem !important;"></div>
                                        <div class="adjust-to-top ">
                                            <div class="d-flex">
                                                <div class="status-stages-circle-inner-padding status-stages-circle-inner-border-grey pointer-event" style="pointer-events: auto;" 
                                                v-if="(
                                                        ((change_status == 'Re-Open' || change_status == 'In progress') && item.name == 'Open') 
                                                        || (change_status == 'Fixed' && (item.name == 'Open' || item.name == 'In progress'))
                                                        || (change_status == 'Closed' && (item.name == 'Open' || item.name == 'In progress' || item.name == 'Fixed')
                                                        || (change_status == 'Discard' && (item.name == 'Closed' || item.name == 'In progress' || item.name == 'Fixed')))
                                                    )">
                                                    <div class="status-stages-circle-inner">
                                                        <div class="status-stages-circle-inner-active-grey">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="status-stages-circle-inner-padding status-stages-circle-inner-border-green pointer-event" style="pointer-events: auto;" v-else-if="item.status == 'active'">
                                                    <div class="status-stages-circle-inner">
                                                        <div class="status-stages-circle-inner-active-blue">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="status-stages-circle-inner-padding bg-white pointer" :class="{'pointer-event': save_loader}" style="pointer-events: auto;"  @click="changeStatusValue(item.name, index)" v-else-if="item.status == 'enabled' || item.status == 'disabled' || item.status == 'success'">
                                                    <div class="status-stages-circle-inner">
                                                        <div class="bg-white"></div>
                                                    </div>
                                                </div>
                                                <div class="pt-1 ml-7 fw-500 w-150px">
                                                    <div class="fs-14">
                                                        {{item.name}}
                                                    </div>
                                                </div>
                                                <div class="status-stages-box-inner-padding status-stages-box-inner-border-grey pointer-event" style="pointer-events: auto;" 
                                                v-if="(
                                                        ((change_status == 'Re-Open' || change_status == 'In progress') && item.name == 'Open') 
                                                        || (change_status == 'Fixed' && (item.name == 'Open' || item.name == 'In progress'))
                                                        || (change_status == 'Closed' && (item.name == 'Open' || item.name == 'In progress' || item.name == 'Fixed')
                                                        || (change_status == 'Discard' && (item.name == 'Closed' || item.name == 'In progress' || item.name == 'Fixed')))
                                                    )">
                                                    <div class="status-stages-box-inner">
                                                        <div class="status-stages-circle-inner-active-grey">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="status-stages-box-inner-padding status-stages-box-inner-border-green pointer-event" style="pointer-events: auto;" v-else-if="item.status == 'active'">
                                                    <div class="status-stages-box-inner">
                                                        <div class="status-stages-box-inner-active-blue">
                                                            <i class="icon icon-check fs-20 fw-600 custom-check-icon"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="status-stages-box-inner-padding bg-white pointer" :class="{'pointer-event': save_loader}" style="pointer-events: auto;"  @click="changeStatusValue(item.name, index)" v-else-if="item.status == 'enabled' || item.status == 'disabled' || item.status == 'success'">
                                                    <div class="status-stages-box-inner">
                                                        <div class="bg-white"> <i class="icon icon-check fs-20 fw-600 custom-check-icon"></i></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border-bottom mt-15"></div>
                            <div class="d-flex align-items-center mt-5">
                                <button v-if="(ticket_status == 'Closed' || ticket_status == 'Fixed') && showDetails.template_type != 'multi_part'" class="btn btn-secondary text-capitalize fs-13 mr-12" @click="reOpenTicket" style="border-radius: 4px !important;height: 30px;line-height: 30px;">Re-Open</button>
                                <button class="btn btn-smm  btn-default text-black btn-success-border-radius btn-discarded" @click="showDiscardTicket" v-if="ticket_status != 'Discard'" style="border-radius: 4px;">Discard</button>
                            </div>
                            <div class="status-change-end"></div>
                            
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <signature-status @updateClosedStatus="updateClosedStatus" modal_name="signature-status" :customer_name="customer_name" :closed_ticket="closed_ticket"></signature-status>
        <discard-ticket v-if="show_discard_ticket" @hideDiscardTicket="hideDiscardTicket" modal_name="discard-ticket" :showDetails="showDetails" @updateDiscardStatus="updateDiscardStatus"></discard-ticket>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import ticket from '../mixins/ticket.js';
import { SweetModal } from 'sweet-modal-vue';
const SignatureStatus = () => import("./SignatureStatus");
const DiscardTicket = () => import("./DiscardTicket");
import { EventBus } from '../eventBus/nav-bar-event.js';
export default {
    props:['modal_name','status','closed_ticket', 'customer_name', 'template_type', "showDetails"],
    mixins:[ticket],
    components:{
        SignatureStatus,
        HalfCircleSpinner,
        SweetModal,
        DiscardTicket
    },
    data(){
        return{
            change_status:'',
            success_msg:'',
            warning_msg:'',
            status_validation:[],
            api_options:[],
            customer_survey:false,
            reason:'',
            feedBack:false,
            job_type: '',
            ticket_status: '',
            save_btn_disabled: false,
            loader: false,
            save_loader: false,
            show_discard_ticket: false
        }
    },
    methods:{
        showDiscardTicket() {
            EventBus.$emit('ZindexChangeStart')
            this.show_discard_ticket = true
            setTimeout(() => {
                this.$modal.show('discard-ticket');
            }, 500);
        },
        hideDiscardTicket() {
            this.show_discard_ticket = false
            setTimeout(() => {
                this.$modal.hide('discard-ticket');
            }, 500);
            EventBus.$emit('ZindexChangeEnd')
        },
        updateDiscardStatus(){
            this.change_status = 'Discard'
            this.$emit('updateStatus', this.change_status)
            this.change_status = ''
        },
        closeFilters(){
            this.change_status = ''
            this.$modal.hide(this.modal_name);
            this.$emit('cancelStatus')
        },
        reOpenTicket() {
            this.change_status = 'Re-Open';
            this.save()
        },
        save(){
            this.confirmSave()
        },
        async confirmSave(){
            this.save_btn_disabled = true;
            this.save_loader = true
            try {
                let params ={
                    status:this.change_status,
                    ticket_id:this.showDetails.ticket_id
                }
                if(params.status == 'reject' || params.status == 'Reject'){
                    params['reason'] = this.reason
                }
                let res = await this.changeStatus(params)
                this.success_msg = res.response
                // this.$refs.success_modal.open();
                // setTimeout(() => {
                //     this.$refs.success_modal.close();
                // }, 2000);
                this.$modal.hide(this.modal_name);
                this.$emit('updateStatus', this.change_status)
                this.change_status = ''
                EventBus.$emit('RecallNotification')
                EventBus.$emit('RecallStatusTabs')
            } catch (reason) {
                this.save_btn_disabled = false;
                this.save_loader = false
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        updateClosedStatus(){
            this.$emit('updateStatus', this.change_status)
            this.change_status = ''
        },
        fixedStatus(){
            this.$emit('updateStatus', this.change_status)
            this.change_status = ''
        },
        async getDetails(){
            try {
                this.loader = true
                let params = {
                    ticket_id:this.showDetails.ticket_id
                } 
                let res = await this.getStatusOfTicket(params)
                this.status_validation = res.response.status_validation
                this.customer_survey = res.response.customer_survey
                this.status_validation.forEach((myArray,index)=>{
                    for (var key in myArray) {
                        this.api_options.push({name: key, value: false})
                    }
                })
                this.loader = false
                this.dataDestructure(this.change_status);
            } catch (reason) {
                this.loader = false
            }
        },
        async getJobTypeOfTicket() {
            try {
                let params = {
                    ticket_id:this.showDetails.ticket_id
                } 
                let res = await this.getTicketById(params)
                this.job_type = res.response.general_details.job_type;
            } catch (reason) {
                
            }
        },
        dataDestructure(value) {
            switch (value) {
                case 'In progress':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'active'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'enabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'enabled' 
                                break;
                        };
                    })
                    break;
                case 'Closed':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'success'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'active'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'enabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'success' 
                                break;
                        };
                    })
                    break;
                case 'Re-Open':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'active' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'enabled' 
                                break;
                        };
                    })
                    break;
                case 'Fixed':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'success'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'enabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'active' 
                                break;
                        };
                    })
                    break;
                case 'Discard':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'enabled' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'enabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'enabled' 
                                break;
                        };
                    })
                    break;
                case 'Open':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'active' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'disabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'enabled' 
                                break;
                        };
                    })
                    break;
            }
        },
        changeStatusValue(value, index){
            this.change_status = value;
            switch (value) {
                case 'In progress':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'active'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Open':
                                if(this.ticket_status == 'In progress'){
                                    this.api_options[index].status = 'success' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'success' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                            case 'Re-Open':
                                if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                            case 'Fixed':
                                if(this.ticket_status == 'In progress'){
                                    this.api_options[index].status = 'enabled' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                        };
                    })
                    break;
                case 'Closed':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                if(this.ticket_status == 'Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else if(this.ticket_status == 'In progress'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'success'
                                }
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'active'
                                break;
                            case 'Open':
                                if(this.ticket_status == 'Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'success'
                                } 
                                break;
                            case 'Re-Open':
                                if(this.ticket_status == 'Fixed'){
                                    this.api_options[index].status = 'enabled' 
                                } else if(this.ticket_status == 'Closed') {
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'disabled' 
                                }
                                break;
                            case 'Fixed':
                                if(this.ticket_status == 'Fixed'){
                                    this.api_options[index].status = 'enabled' 
                                } else if(this.ticket_status == 'Closed') {
                                    this.api_options[index].status = 'success';
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                        };
                    })
                    break;
                case 'Re-Open':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'success'
                                }
                                break;
                            case 'Closed':
                                if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'disabled' 
                                } else {
                                    this.api_options[index].status = 'enabled'
                                }
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                if(this.ticket_status == 'Closed'){
                                    this.api_options[index].status = 'active' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'active' 
                                } else if(this.ticket_status == 'Fixed'){
                                    this.api_options[index].status = 'active' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                            case 'Fixed':
                                if(this.ticket_status == 'Closed'){
                                    this.api_options[index].status = 'success' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                        };
                    })
                    break;
                case 'Fixed':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                if(this.ticket_status == 'Fixed'){
                                    this.api_options[index].status = 'success' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                            case 'Closed':
                                if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else if(this.ticket_status == 'In progress'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'enabled'
                                }
                                break;
                            case 'Open':
                                if(this.ticket_status == 'Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'success' 
                                }
                                break;
                            case 'Re-Open':
                                if(this.ticket_status == 'In progress'){
                                    this.api_options[index].status = 'disabled' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'active' 
                                break;
                        };
                    })
                    break;
                case 'Open':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'active' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'enabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'enabled' 
                                break;
                        };
                    })
                    break;
            }
            this.$forceUpdate();
            setTimeout(() => {
                this.save()
            }, 500);
        }
    },
    mounted(){
        this.getDetails()
        this.getJobTypeOfTicket()
        this.change_status = this.status;
        this.ticket_status = this.status;
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    },
    watch:{
        'status'(newValue,oldValue){
            if(newValue){
                this.change_status = this.status
            }
        }
    }
}
</script>
<style scoped>
    .btn-discarded{
        background-image: linear-gradient(to bottom, #9fc8f4, #3883d5)!important;
    }
    .w-150px{
        width:150px;
    }
    .custom-check-icon{
        line-height: 18px !important;
        color:white
    }
    .border-bottom{
        border-top: 2px solid #a5a5a5 !important;
    }
    .change-status{
        display: flex;
        flex-direction: column;
    }
    .ticket-status-text-blue {
        padding: 11.3px 20px;
        object-fit: contain;
        color: #fff;
        line-height: 2.2;
        background-image: linear-gradient(to right, #07458b, #0e7efa);
    }
    .ticket-status-green {
        padding: 11.3px 20px;
        object-fit: contain;
        color: #fff;
        line-height: 2.2;
        background-image: linear-gradient(to right, #004532, #008a63);
    }
    
    .status-stages-line {
    height: 61%;
    width: 2.5px;
    background-image: linear-gradient(to bottom, #130e0e 50%, transparent 50%);
    background-size: 2.5px 5px;
}

    .status-stages-circle-inner {
        height: 20px;
        width: 20px;
        margin: 0 auto;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        /* background-color: #a3a3a3; */
    }
    .status-stages-box-inner {
        height: 20px;
        width: 20px;
        margin: 0 auto;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        /* background-color: #a3a3a3; */
    }
    .status-stages-circle-inner-active-blue {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        /* background-color: #0a5fbe; */
    }
   
    .status-stages-box-inner-active-blue {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        /* background-color: #0a5fbe; */
    }
    .status-stages-circle-inner-active-green {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('/static/images/status_green.svg');
    }
    .status-stages-box-inner-active-green {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('/static/images/status_green.svg');
    }
    .status-stages-circle-inner-active-grey {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        /* background-color: #c4c4c4; */
    }
    .status-stages-box-inner-active-grey {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        background-color: #c4c4c4;
    }
    .status-change-end {
        background-color: #206ad3;
        width: 7px;
    }
    .status-stages-circle-inner-padding {
        padding: 2px;
        width: 30px;
        background-color: #fff;
        height: 30px;
        /* margin: 0 auto; */
        border: 7.5px solid #f4b7ac;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .status-stages-box-inner-padding {
        padding: 2px;
        width: 25px;
        background-color: #fff;
        height: 25px;
        z-index:100;
        /* margin: 0 auto; */
        border: solid 0.5px #130e0e;
        /* border-radius: 50%; */
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .status-stages-circle-inner-border-blue {
        border-color: #0a5fbe;
    }
    .status-stages-box-inner-border-blue {
        border-color: #0a5fbe;
    }
    .status-stages-circle-inner-border-green {
        border-color: #388e3c;
    }
    .status-stages-box-inner-border-green {
        border-color: #388e3c ;
        background-color:#388e3c ;
    }
    .status-stages-circle-inner-border-grey {
        border-color: #f1f1f1;
        /* background-color: #c4c4c4; */
    }
    .status-stages-box-inner-border-grey {
        border-color: #f1f1f1;
        background-color: #f1f1f1;
    }
    .status-stages-circle-text-blue {
        color: #0a5fbe;
    }
    .status-stages-circle-text-green {
        color: #008a63;
    }
    .status-stages-circle-text-grey {
        color: #a3a3a3;
    }
    .adjust-to-top {
        /* margin-top: -15px; */
    }
    .background-color-grey {
        background-color: #a3a3a3;
    }
    .inverse div{
        position: absolute;
        top: 27px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #fff;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .text-align-left{
        text-align: left !important;
    }
    .btn-new-discard {
        /* padding: 4.8px 8.3px 4.8px 11.8px; */
        border-radius: 4px;
        background-color: #cce3fc;
        color: #130e0e;
        height: 30px;
        line-height: 30px;
    }
    .helpdesk-ticket{
        position: absolute;
        top: 55px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        border-radius: 4px;
        z-index:1;
        right:0;
    }
    .ticket-header{
        background-color: #f0ddb7 !important;
    }

    .ticket-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 90px;
    background-color: #f0ddb7 !important;
    color: #130e0e !important;
    }
    .general-section{
        background-color: #ffffff !important;
    }

    .margin-top-hide{
        margin-top: 45px !important;
        background-image: none !important

    }
</style>